import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const AggregatorApiPaths: IPaths = {
  SabtAhval: {
    EstelamSabtAhval: 'SabtAhval/EstelamSabtAhval',
    EstelamForeignNationality: 'SabtAhval/EstelamForeignNationality',
  },
  PostCode: {
    GetAddressWithPostCode: 'PostCode/GetAddressWithPostCode',
  },
};
